import { FETCH_CHAT_NEW_MESSAGES} from '../../constants/ActionTypes';
import axios from 'axios';


export default function fetchChatNewMessages() {

  const promise=axios.get(`/api/privatechat/new_messages`);

  const action={
    type: FETCH_CHAT_NEW_MESSAGES,
    payload: promise
  };

  return action;

}

